module.exports = __webpack_public_path__ + "static/banner-17a5b3ca533f05183578bdb8c01eb4d3.png";